export default __webpack_public_path__ + "21bf062a6a589adc85304187d0ea8911.png";